import Vue from 'vue';
import store from '@/store';
export function has(value){
	let flag = false;
	let permissionArr = store.state.permission;
	if (permissionArr.length == 0) {
		return false
	} else {
	  for (let i = 0;i < permissionArr.length;i++) {
		  if (permissionArr[i] == value) {
			  flag = true;
			  break;
		  }
	  }
    }
	return flag;
}



// WEBPACK FOOTER //
// ./src/common/js/btn_permission.js